/* eslint-disable camelcase */
import axios from 'axios'
import i18n from '../i18n'
import configurations from '../configurations'

const defaultData = {
  type: 'council_license',
  status: 'submitted',
  timestamp: new Date().toISOString(),
  business: {
    category: '',
    trading_no: ''
  },
  owner: { sameAsMail: false, mail_state: 'Sabah', state: 'Sabah', marital_status: 'single' }
}

const form = {
  namespaced: true,
  state: {
    categories: [],
    council: configurations.council,
    data: Object.assign({}, defaultData),
    error: null,
    items1: [],
    items2: [],
    items3: [],
    id: null,
    loading: false
  },
  getters: {
    isLoading: function (state, getters, rootState, rootGetters) {
      return state.loading
    }
  },
  mutations: {
    setCategories: (state, payload) => (state.categories = payload.categories),
    setError: function (state, payload = { error: null }) {
      state.error = payload.error
    },
    setLoading: function (state, payload = { loading: false }) {
      state.loading = payload.loading
    },
    setData: function (state, payload = { data: defaultData }) {
      state.data = payload.data
    },
    resetData: function (state) {
      state.data = Object.assign({}, defaultData)
    },
    patchApplicant: function (state, { applicant }) {
      state.data.applicant = Object.assign({}, state.data.applicant, applicant)
    },
    patchBusiness: function (state, { business }) {
      state.data.business = Object.assign({}, state.data.business, business)
    },
    patchBusinessActivity: function (state, { business_activity }) {
      if (state.data.business.business_activity.indexOf(business_activity) === -1) {
        state.data.business.business_activity.push(business_activity)
      }
    },
    removeBusinessActivity: function (state, { business_activity }) {
      for (var i = 0; i < state.data.business.business_activity.length; i++) {
        if (state.data.business.business_activity[i] === business_activity) {
          state.data.business.business_activity.splice(i, 1)
        }
      }
    },
    patchCouncilLicense: function (state, { council_license, index }) {
      state.data.council_license[index] = Object.assign({}, state.data.council_license[index], council_license)
    },
    patchOwner: function (state, { owner }) {
      state.data.owner = Object.assign({}, state.data.owner, owner)
    },
    patchManager: function (state, { manager }) {
      state.data.manager = Object.assign({}, state.data.manager, manager)
      delete state.data.manager.ownership_type
    },
    resetOwner: function (state) {
      state.data.owner = Object.assign({}, defaultData.owner)
    },
    resetManager: function (state) {
      state.data.manager = Object.assign({}, defaultData.manager)
    },
    setItems: function (state, { data }) {
      for (var i = 0; i < data.length; i++) {
        state.items1.push({ value: data[i].type, premise: data[i].premise })
        state.items2.push({ value: data[i].category, type: data[i].type, premise: data[i].premise })
        state.items3.push({ value: data[i].activity, type: data[i].category, premise: data[i].premise })
      }
    }
  },
  actions: {
    fetchData: async function (context, payload) {
      context.commit('setLoading', { loading: true })
      try {
        const { data } = await axios.get(`/licenses/${payload.type}/${payload.id}`)
        context.commit('setData', { data })
        context.commit('setError', { error: null })
      } catch (error) {
        context.commit('setError', { error })
        this.dispatch('snackbar/setSnackBar', {
          color: 'error',
          message: i18n.t('fetching_data_failed'),
          visible: true
        })
        throw error
      } finally {
        context.commit('setLoading', { loading: false })
      }
    },
    fetchCategories: async function (context, payload) {
      context.commit('setLoading', { loading: true })
      try {
        // const [responseCategories] = await Promise.all([
        //   pouchdb.council_operation.allDocs({
        //     startkey: `CLOC-`,
        //     endkey: `CLOC-\uffff`,
        //     include_docs: true
        //   })
        // ])
        // const categories = responseCategories.rows.length > 0 ? responseCategories.rows.map(row => row.doc) : []
        // context.commit('setCategories', { categories })
        context.commit('setError', { error: null })
      } catch (error) {
        context.commit('setError', { error })
        this.dispatch('snackbar/setSnackBar', {
          color: 'error',
          message: i18n.t('fetching_data_failed'),
          visible: true
        })
        throw error
      } finally {
        context.commit('setLoading', { loading: false })
      }
    },
    resetData: async function (context, payload = {}) {
      context.commit('setData', { data: defaultData })
    },
    submitData: async function (context, payload = {}) {
      context.commit('setLoading', { loading: true })
      try {
        const { data: result } = await axios.post(`/licenses/${payload.license.type}/applications/submit`, payload)
        return result
      } catch (error) {
        context.commit('setError', { error })
        if (error.response && error.response.data && error.response.data.error === 'conflict') {
          this.dispatch('snackbar/setSnackBar', {
            color: 'error',
            message: i18n.t('email_already_exist'),
            visible: true
          })
        } else {
          this.dispatch('snackbar/setSnackBar', {
            color: 'error',
            message: i18n.t('attempt_failed_please_try_again'),
            visible: true
          })
        }
        // throw error
      } finally {
        context.commit('setLoading', { loading: false })
      }
    }
  }
}

export default form
